(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxConditionString', {
		bindings: {
			condition: '=',
		},
		controller: MxConditionStringCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-condition-builder/by-type/mx-condition-string.html',
	});

	MxConditionStringCtrl.$inject = ['mx.internationalization'];

	function MxConditionStringCtrl(i18n) {
		var vm = this;
		vm.i18n = i18n.get('solutionBuilderAgent.components.mx-conditions-builder');

		vm.$onInit = function () {};

		return vm;
	}
})();
